import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
export const ConfirmDeleteUser = ({ disabled = false, onDelete }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleDelete = () => {
        onDelete();
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", variant: "contained", color: "secondary", startIcon: React.createElement(DeleteIcon, null), disabled: disabled, onClick: handleClick }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
        React.createElement(Menu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose },
            React.createElement(MenuItem, { onClick: handleDelete }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"),
            React.createElement(MenuItem, { onClick: handleClose }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"))));
};
